import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormRs009Build } from './forms-build/form-rs009-build';

export class FormRs009 extends FormRs009Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            offline: true,
            cerar: ['', [Validators.required]],
            lote_rw: ['', []],
            cooperante: ['', []],
            gleba: ['', []],
            contrato_juridico: ['', []],
            numero_campo: ['', []],
            produto: ['', []],
            peso_amostra: ['', []],
            peso_liquido: ['', []],
            palha: ['', []],
            outras_sementes: ['', []],
            impurezas: ['', []],
            palha_imp_esp: [0, []],
            graos_ardidos: ['', []],
            // esclerocitos: ['', []],
            desconto_palha: [0, []],
            sabugo_milho: ['', []],
            quantidade_palha: [0, []],
            quantidade_palha_milho: [0, []],
            quantidade_sabugo: [0, []],
            desconto_palha_imp: [0, []],
            peso_graos_amostra: [0, []],
            quantidade_impurezas: [0, []],
            graos_carunchados: ['', []],
            // descarte_grao: ['', []],
            sementes_quebradas: ['', []],
            outros_cultivares: ['', []],
            sementes: [0, []],
            sub_total_descarte: [0, []],
            sub_total_descart_prc: [0, []],
            // sementes_redondas: ['', []],
            // fracao_sementes: ['', []],
            // semente_peneira: ['', []],
            semente_redonda_prc: [0, []],
            semente_peneira_intermediaria: [0, []],
            semente_peneira_fundo: [0, []],
            sub_total_descarte_amostra: [0, []],
            // total_des_grao: ['', []],
            // umidade_direcionamento: ['', []],
            umidade: [0, []],
            umidade_deducao: [0, []],
            desconto_impureza_palha: [0, []],
            desconto_sabugo: [0, []],
            total_desconto: [0, []],
            peso_liquido_umido: [0, []],
            desconto_umidade: [0, []],
            peso_liquido_seco: [0, []],
            descarte_graos: [0, []],
            total_semente: [0, []],
            rendimento_milho: [0, []],
            rendimento_rw_mpl: [0, []],
            site_origem: ['', []],
            observacao: ['', []],
            site_recebimento: ['', []],
            validacao: [false, []],
            created_by: [null, []],
            resp_validacao: ['', []],
            safra: ['', []],
            qnt_espiga_caixa: ['', []],
            espiga_atipica: ['', []],
            prc_espiga_atipica: ['', []],
            morte_prematura: ['', []],
            prc_morte_prematura: ['', []],
            cerar_basica: ['', []],
            geracao: ['', []],
            safra_basica: ['', []],
            hibrido_rnc: ['', []],
            especie: ['', []],
            tipo_colheita: ['', []],
            amostra_seca_molhada: ['', []],
            peso_total_rw: ['', []],
            peso_sementes: ['', []],
            peso_material: ['', []],
            sabugo_cerar: ['', []],
            espigas_atipicas: ['', []],
            descarte_mesa: ['', []],
            observacao_amostra: ['', []],
            palha_impureza_cerar: ['', []],
            semente_cerar: ['', []],
            palha_amostra: ['', []],
            peso_liquido_carga_umidade: ['', []],
            palha_na_carga: ['', []],
            previsao_mpl_kg: ['', []],
            previsao_mpl_porcento: ['', []],
            previsao_ds_graos_kg: ['', []],
            previsao_ds_graos_porcento: ['', []],
            perda_processo: ['', []],
            origem_negocio: ['', []],
        });
        return formulario;
    }
}
